import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";

import { SportBlogConfigService } from "./sport-blog.config";

@Injectable({ providedIn: "root" })
export class SportBlogGuard implements CanActivate {
	constructor(private sportBlogConfigService: SportBlogConfigService) {}

	canActivate(): boolean {
		return this.sportBlogConfigService.isSportBlogEnabled();
	}
}
